// Gegevens van de organisatie zelf: de naam. Dat is de club, bond of
// organisator, niet het toernooi. Alleen met org.manage (owner).
import { getClient } from '../data/supabase.js';
import { state } from '../state.js';
import { heeft } from '../router.js';
import { t } from '../lib/i18n.js';
import { esc } from '../lib/format.js';
import { toast } from '../ui/toast.js';
import { refLabel } from '../ui/ref.js';

const sb = () => getClient();

export function renderKaart(naWijzigen) {
  const el = document.getElementById('organisatieKaart');
  if (!el) return;
  el.hidden = !heeft('org.manage');
  if (el.hidden) return;
  const typen = (state.currentOrg?.types || []).map(tp => t('start.type.' + tp)).join(', ');
  el.innerHTML = `<h3>${esc(t('organisatie.titel'))} ${refLabel(state.currentOrg?.ref)}</h3>
    <div class="settings-desc">${esc(t('organisatie.uitleg'))}</div>
    <div class="act-rij">
      <div class="form-group"><label class="form-label">${esc(t('organisatie.naam'))}</label>
        <input class="form-input" name="orgNaam" value="${esc(state.currentOrg?.name || '')}"></div>
      <button type="button" class="btn btn-default btn-sm" data-org="opslaan"><i class="ti ti-device-floppy"></i> ${esc(t('act.opslaan'))}</button>
    </div>
    ${typen ? `<p style="font-size:12px;color:var(--text-3);margin-top:8px">${esc(t('organisatie.type', { typen }))}</p>` : ''}`;
  el.onclick = async e => {
    if (!e.target.closest('[data-org="opslaan"]')) return;
    const naam = el.querySelector('[name="orgNaam"]').value.trim();
    if (naam.length < 2) { toast(t('eigendom.fout.naam_ontbreekt'), 'error'); return; }
    const { error } = await sb().from('organisations').update({ name: naam }).eq('id', state.currentOrgId);
    if (error) { toast(t('alg.fout', { melding: error.message }), 'error'); return; }
    if (state.currentOrg) state.currentOrg.name = naam;
    toast(t('organisatie.opgeslagen'), 'success');
    if (naWijzigen) naWijzigen();
  };
}
